var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-footer__container"},[_c('new-l-link',{attrs:{"context":"secondary"},on:{"click":_vm.onRemoveFilters}},[_vm._v("\n      Remover filtros\n  ")]),_c('oz-button-number',{staticClass:"js-modal-footer-cta",attrs:{"disabled":_vm.isDisabled},on:{"updateFilters":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }